import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

/**
 * Renders markdown text safely. Supports: **bold**, *italic*, ***both***, - lists
 * Single line breaks (\n) are preserved thanks to remark-breaks.
 */
export function MarkdownText({ children, className = "" }) {
  if (!children) return null;
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]}
        components={{
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
          em: ({ children }) => <em className="italic">{children}</em>,
          ul: ({ children }) => <ul className="list-disc list-inside ml-2 mb-2">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal list-inside ml-2 mb-2">{children}</ol>,
          li: ({ children }) => <li className="mb-0.5">{children}</li>,
          a: ({ children }) => <span>{children}</span>,
          img: () => null,
          h1: ({ children }) => <p className="font-bold mb-1">{children}</p>,
          h2: ({ children }) => <p className="font-bold mb-1">{children}</p>,
          h3: ({ children }) => <p className="font-bold mb-1">{children}</p>,
        }}
        allowedElements={["p", "strong", "em", "ul", "ol", "li", "br", "h1", "h2", "h3"]}
        unwrapDisallowed={true}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
